/**
 * /match/request 비용 키워드 유입 → 온보딩 화면 (구 실험 #321 B, 실험 종료 후 상시 채택).
 *
 * 노출 조건 (무빈소 패턴):
 *  - 광고 유입(n_query/n_ad/gclid) + 키워드에 아래 토큰 포함(부분 매칭). 확장검색 유입도 여기서 잡힘.
 *  - ?template=cost 명시 쿼리(결정적, 새로고침에도 유지) — 마케팅 링크용.
 *
 * 무빈소 다음 우선순위로 판정(키워드가 겹칠 수 있으나 무빈소를 먼저 흡수).
 */

/** 비용 관심 유입 판정 토큰. 키워드에 하나라도 포함되면 비용 온보딩 노출. */
const COST_KEYWORD_TOKENS = ["비용", "가격", "견적", "사용료", "요금"];

const normalize = (s: string) => s.replace(/\s+/g, "");

/**
 * n_query/utm_term에 비용 관심 토큰이 포함되는지 판정(부분 매칭, 공백 무시).
 * @param keyword useAdKeywordTargeting()의 keyword (n_query || utm_term)
 */
export const isCostAdKeyword = (keyword?: string | null) => {
  if (!keyword) return false;
  const normalized = normalize(keyword);
  return COST_KEYWORD_TOKENS.some((token) => normalized.includes(token));
};

/**
 * 비용 온보딩 유입 마킹용 sessionStorage 키.
 * 퍼널 끝 로그인 페이지에서 "미리 알면 수백만 원 아껴요" 화면을 노출하기 위한 신호.
 * (온보딩 렌더 시 마킹 → 로그인이 sessionStorage로 판정. 퍼널·로그인 네비게이션이 공용이라 별도 신호 필요)
 */
const COST_SAVINGS_LOGIN_KEY = "match_request_cost_onboarding";

/** 비용 온보딩 노출 시 마킹(컨테이너에서 온보딩 렌더 시 호출). */
export const markCostSavingsLogin = () => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(COST_SAVINGS_LOGIN_KEY, "1");
};

/** 비용 온보딩 유입 여부(로그인 페이지 전용 처리). sessionStorage는 클라 전용이라 렌더 시 호출. */
export const isCostSavingsLogin = () =>
  typeof window !== "undefined" && sessionStorage.getItem(COST_SAVINGS_LOGIN_KEY) !== null;
